import {
	ApiUtils,
	_axios
} from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/stus/student/list", params, successCallback, failCallback, exceptionCallback);
	},
	getStulist: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/stus/student/getStulist", params, successCallback, failCallback, exceptionCallback);
	},
	intnStu(params, successCallback, failCallback, exceptionCallback) {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/stus/student/intnStu", params, successCallback, failCallback, exceptionCallback);
	},
	toImport(params, successCallback, failCallback, exceptionCallback) {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/stus/student/toImport", params, successCallback, failCallback, exceptionCallback);
	},
	imports: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/stus/student/imports", params, successCallback, failCallback, exceptionCallback);
	},
 
	save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/stus/student/save", params, successCallback, failCallback, exceptionCallback);
	},
	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/stus/student/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/stus/student/update", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/stus/student/remove", params, successCallback, failCallback, exceptionCallback);
	},
	reBind: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/stus/student/relaxXCX", params, successCallback, failCallback, exceptionCallback);
	},
	revise: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/stus/student/revise", params, successCallback, failCallback, exceptionCallback);
	},intnStu(params, successCallback, failCallback, exceptionCallback){
		ApiUtils.getLoadingAjax(constant.serverUrl + "/stus/student/intnStu", params, successCallback, failCallback, exceptionCallback);
	},
   	updateAll: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/stus/student/updateAll", params, successCallback, failCallback, exceptionCallback);
	}, 
	//查询该班级学生
	toStus: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/stus/student/toStus", params, successCallback, failCallback, exceptionCallback);
	},stuInClass: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/stus/student/stuInClass", params, successCallback, failCallback, exceptionCallback);
	},stuInClass1: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/stus/student/stuInClass1", params, successCallback, failCallback, exceptionCallback);
	},stuInClass2: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/stus/student/stuInClass2", params, successCallback, failCallback, exceptionCallback);
	},
	//修改全班学生默认密码
	updStuPwd: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/stus/student/updStuPwd", params, successCallback, failCallback, exceptionCallback);
	},
	//统计班级学生人数
	ClazzStusNum: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/stus/student/clazzstusnum", params, successCallback, failCallback, exceptionCallback);
	},tiyan :(params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/stus/student/tiyan", params, successCallback, failCallback, exceptionCallback);
	}
}

export default api;
